// Summaries of the log sent by Home and the maintenance overview, as activity entries (US 9438)

const HOME_ACTIONS = {
  signed_off: 'signed',
  completed: 'signed',
  delivered: 'uploaded',
  rejected: 'status',
  returned: 'status'
};

const MAINTENANCE_ICONS = {
  user: 'user',
  data_objects: 'database',
  process_groups: 'layer-group',
  organizations: 'building',
  legal_basis: 'balance-scale',
  data_subjects: 'users',
  information_obligation: 'info-circle',
  retention_rules: 'hourglass-half',
  risk_categories: 'tags',
  threats: 'crosshairs',
  vulnerabilities: 'virus'
};

const MAINTENANCE_ACTIONS = {
  created: 'created',
  added: 'created',
  deleted: 'deleted',
  removed: 'deleted'
};

// Home "On your work": { id, action, user (name), task, project, created_at }
export function homeEntry(vm, row) {
  const item = { kind: 'task', type: '', icon: 'check-square', name: row.task, to: null };
  return {
    id: 'home-' + row.id,
    time: row.created_at,
    causer: row.user ? { name: row.user } : null,
    action: HOME_ACTIONS[row.action] || 'updated',
    sentence: { path: 'activity_log.home.' + row.action, item: item, parent: null, values: {} },
    context: row.project || null,
    changes: [],
    values: [],
    notes: []
  };
}

// Maintenance "Recent changes": { id, action, type, name, user: { id, name }, created_at }
export function maintenanceEntry(vm, row) {
  const type = vm.$t('maintenance_overview.types.' + row.type);
  const item = { kind: row.type, type: type.charAt(0).toUpperCase() + type.slice(1), icon: MAINTENANCE_ICONS[row.type] || 'th-large', name: row.name || '–', to: null };
  const action = row.action.replace(/_/g, ' ');
  const known = ['created', 'updated', 'deleted'].indexOf(action) !== -1;
  const verbKey = 'actions.' + row.action;
  return {
    id: 'maintenance-' + row.id,
    time: row.created_at,
    causer: row.user || null,
    action: MAINTENANCE_ACTIONS[action] || 'updated',
    sentence: {
      path: known ? 'activity_log.sentence.' + action : 'activity_log.sentence.generic',
      item: item,
      parent: null,
      values: { verb: vm.$te(verbKey) ? vm.$t(verbKey) : action }
    },
    changes: [],
    values: [],
    notes: []
  };
}
